<div
  class="meter"
  [class]="toneClass()"
  role="meter"
  [attr.aria-valuenow]="strength()"
  aria-valuemin="0"
  aria-valuemax="4">
  @for (i of bars(); track i) {
    <span class="meter__bar" [class.meter__bar--on]="isActive(i)"></span>
  }
</div>
